import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../assets/my_fridge.png";
import logotext from "../assets/my_fridge_text.png";
import DarkModeToggle from "./DarkModeToggle";

const NavigationBar = () => {
    return (
        <>
            <Navbar style={{backgroundColor: "#81cd81",fontWeight: "bold"}} expand="lg" className="mb-4">
                <Container>
                    <Navbar.Brand as={Link} to="/">
                        <img src={logo} alt="Logo" className="logo me-2"/>
                        <img src={logotext} alt="Logo" className="logotext me-2"/>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <Nav.Link as={Link} to="/ingredients">📋 Ingredience</Nav.Link>
                            <Nav.Link as={Link} to="/shopping-list">🛒 Nákupní seznam</Nav.Link>
                            <Nav.Link as={Link} to="/recipes">🍽️ Recepty</Nav.Link>
                            <Nav.Link as={Link} to="/notifications">🔔 Upozornění</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default NavigationBar;
